module.exports = __webpack_public_path__ + "static/media/levelsResponsibility.61eae19b.jpg";